import { render, staticRenderFns } from "./softLi.vue?vue&type=template&id=2dfc3fd6&scoped=true"
import script from "./softLi.vue?vue&type=script&lang=js"
export * from "./softLi.vue?vue&type=script&lang=js"
import style0 from "./softLi.vue?vue&type=style&index=0&id=2dfc3fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc3fd6",
  null
  
)

export default component.exports